import {
  View,
  Text,
  ActivityIndicator,
  TextInput
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import Card from '../../shared/card/Card'
import { Formik } from 'formik'
import CustomButton from '../../shared/button/Button'
import { globalStyles } from '../../../static/styles/global'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import { usePersonalStore } from '../../../stores/personalInfo'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import Toast from 'react-native-toast-message'
import * as yup from 'yup'
import { CheckBox } from 'react-native-elements'
import { useState, useEffect } from 'react'


const OhInformationForm = ({ navigation, route }: any) => {
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey
    } = params


    const [isApiLoading, setIsApiLoading] = useState(false)
    const [districtData, setDistrictData] = useState({ districtOfResidence: "", schoolDistrictNumber: "" })

    const { loading, postohonline, postOHAutomation } = useFormsStore()
    const initializestore = useInitializeStore()
    const personalstore = usePersonalStore()
    const intialValues = {

        districtOfResidence: districtData.districtOfResidence,
        schoolDistrictNumber: districtData.schoolDistrictNumber,
        isDependent: "",
        isSingle: "",
        noOfDependents: "",
        additionalWithholding: "",
        withholdingWaiver: ""

    }

    useEffect(() => {
        const fetchDistrictData = async () => {
            setIsApiLoading(true);
            try {
                const currentDate = new Date();
                const day = String(currentDate.getDate()).padStart(2, '0');
                const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                const year = String(currentDate.getFullYear());


                // const data = {
                //     address: '50 SOUTH POWELL',
                //     suite: '',
                //     city: 'COLUMBUS',
                //     zip: '43204',
                //     month: '3',
                //     Year: '2026',
                //     day: '9',
                //     taxType: "school",
                // }

                const data = {
                    address: personalstore?.personalData?.addressLine1,
                    suite: personalstore?.personalData?.addressLine2,
                    city: personalstore?.personalData?.city,
                    zip: personalstore?.personalData?.zip,
                    month,
                    year,
                    day,
                    taxType: "school",
                };

                const response = await postOHAutomation(data);
                if (response?.data) {
                    setDistrictData({
                        districtOfResidence: response.data.DistrictName || "",
                        schoolDistrictNumber: response.data.DistrictNumber || ""
                    });
                }
            } catch (error) {
                console.error("Error fetching school district:", error);
            } finally {
                setIsApiLoading(false);
            }
        };

        fetchDistrictData();
    }, [personalstore?.personalData, postOHAutomation]);


    const checkboxData = [
        { id: 0, title: 'I am a full-year resident of Indiana, Kentucky, Michigan, Pennsylvania, or West Virginia', isChecked: false },
        { id: 1, title: 'I am a resident military servicemember who is stationed outside Ohio on active duty military orders', isChecked: false },
        { id: 2, title: 'I am a nonresident military servicemember who is stationed in Ohio due to military orders', isChecked: false },
        {
            id: 3, title: 'I am a nonresident civilian spouse of a military servicemember and I am present in Ohio solely due to my spouse’s military orders', isChecked: false
        },
        {
            id: 4, title: 'I am exempt from Ohio withholding under R.C. 5747.06(A)(1) through (6)', isChecked: false
        },

    ];
    const [checkboxes, setCheckboxes] = useState(checkboxData);

    const toggleCheckbox = (id: number) => {
        const newCheckboxes = checkboxes.map(checkbox =>
            checkbox.id === id ? { ...checkbox, isChecked: !checkbox.isChecked } : { ...checkbox, isChecked: false }
        );
        setCheckboxes(newCheckboxes);
    };



    const getCheckedIds = () => {
        return checkboxes
            .filter(checkbox => checkbox.isChecked)
            .map(checkbox => checkbox.id.toString());
    };

    const w4schema = () => {
        const baseSchema = {
            districtOfResidence: yup.string().required(' School District of residence is a required field'),
            schoolDistrictNumber: yup
                .string()
                .length(4, "School District number must be exactly 4 digits")
                .required("School District number is a required field"),
            isDependent: yup.string().matches(/^(0|1)?$/, 'It must be either 0, 1, or empty'),
            isSingle: yup.string().matches(/^(0|1)?$/, 'It must be either 0, 1, or empty'),
            noOfDependents: yup.string().nullable(),
            additionalWithholding: yup.string().nullable(),
            withholdingWaiver: yup.mixed().nullable()
        }
        return yup.object(baseSchema)
    }
    const schema = w4schema()

    return (
        <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'OH Withholding Taxation '}
                    />
                </View>
            </View>
            <View style={globalStyles.containerOverlap}>
                <Formik
                    initialValues={{ ...intialValues }}
                    enableReinitialize={true}
                    validationSchema={schema}
                    onSubmit={async (values, actions) => {
                        const total = Number(values?.isDependent) + Number(values?.isSingle) + Number(values?.noOfDependents)
                        const ids = getCheckedIds()
                        const data = {
                            entityId: personalstore?.personalData?.entityId,
                            essUserKey:
                                initializestore?.initializeData?.userkey,
                            essObKey: essUserOnBoardingKey,
                            essUserOnBoardingFormKey:
                                essUserOnBoardingFormKey,
                            completeOnline: mode === 'upload' ? false : true,
                            dependentStatus: values?.isDependent ? values?.isDependent : null,
                            singleStatus: values?.isSingle ? values?.isSingle : null,
                            noOfDependents: values?.noOfDependents ? values?.noOfDependents : null,
                            totalWithholdingExemptions: total,
                            additionalWithholding: values?.additionalWithholding ? values?.additionalWithholding : null,
                            withholdingWaiver: getCheckedIds(),
                            districtOfResidence: values?.districtOfResidence,
                            schoolDistrictNumber: values?.schoolDistrictNumber
                        }

                        const response = await postohonline(data)
                        if (response?.success) {
                            if (mode === 'online') {
                                navigation.navigate('OhInformationOnline', {
                                    userId,
                                    mode,
                                    essUserOnBoardingKey,
                                    essUserOnBoardingFormKey,
                                    values,
                                    total,
                                    ids
                                })
                            } else {
                                await Toast.show({
                                    type: 'success',
                                    position: 'bottom',
                                    text1: response?.message,
                                    visibilityTime: 3000,
                                    autoHide: true,
                                    topOffset: 60,
                                    onHide: () => {
                                        navigation.replace('OnboardingForms')
                                    }
                                })
                            }

                        } else {
                            await Toast.show({
                                type: 'error',
                                position: 'bottom',
                                text1: response?.message,
                                visibilityTime: 3000,
                                autoHide: true,
                                topOffset: 60
                            })
                        }

                    }}
                >
                    {(props) => (
                        <View>
                            <Card>
                                {isApiLoading ? <ActivityIndicator size="small" color="#0B495C" style={{ marginTop: 10 }} /> :
                                    <>
                                        <View style={{ marginBottom: 10 }}>

                                            <Text style={[globalStyles.inputLabelPrimary]}>
                                                Please visit <Text style={{ fontWeight: 'bold' }}>School district of residence </Text>to obtain the correct
                                                School district of residence to enter.
                                            </Text>

                                        </View>
                                        <View
                                            style={[
                                                globalStyles.hDirection,
                                                globalStyles.hBetweenItems,
                                                globalStyles.mb2
                                            ]}
                                        >
                                            <View style={{ width: '65%', justifyContent: 'center' }}>
                                                <Text
                                                    style={[
                                                        globalStyles.inputLabel,
                                                        globalStyles.inputLabelLarge,
                                                        globalStyles.inputLabelPrimary
                                                    ]}
                                                >
                                                    {
                                                        'School district of residence *'
                                                    }
                                                </Text>
                                            </View>
                                            <View style={{ width: '30%', overflow: 'hidden' }}>
                                                <TextInput
                                                    style={[globalStyles.input, globalStyles.inputLight]}
                                                    value={props.values.districtOfResidence}
                                                    onChangeText={(text) => {

                                                        props.handleChange('districtOfResidence')(text)

                                                    }}
                                                />
                                                {props.touched.districtOfResidence &&
                                                    props.errors.districtOfResidence && (
                                                        <Text style={globalStyles.dangerAlert}>
                                                            {props.errors.districtOfResidence as string}
                                                        </Text>
                                                    )}
                                            </View>
                                        </View>
                                        <View
                                            style={[
                                                globalStyles.hDirection,
                                                globalStyles.hBetweenItems,
                                                globalStyles.mb2
                                            ]}
                                        >
                                            <View style={{ width: '65%', justifyContent: 'center' }}>
                                                <Text
                                                    style={[
                                                        globalStyles.inputLabel,
                                                        globalStyles.inputLabelLarge,
                                                        globalStyles.inputLabelPrimary
                                                    ]}
                                                >
                                                    {
                                                        'School district number *'
                                                    }
                                                </Text>
                                            </View>

                                            <View style={{ width: '30%', overflow: 'hidden' }}>
                                                <TextInput
                                                    style={[globalStyles.input, globalStyles.inputLight]}
                                                    value={props.values.schoolDistrictNumber}
                                                    keyboardType="numeric"
                                                    onChangeText={(text) => {
                                                        if (text === '' || /^\d+$/.test(text)) {
                                                            props.handleChange('schoolDistrictNumber')(text)
                                                        }
                                                    }}
                                                />
                                                {props.touched.schoolDistrictNumber &&
                                                    props.errors.schoolDistrictNumber && (
                                                        <Text style={globalStyles.dangerAlert}>
                                                            {props.errors.schoolDistrictNumber as string}
                                                        </Text>
                                                    )}
                                            </View>
                                        </View>


                                        <View
                                            style={[
                                                globalStyles.hDirection,
                                                globalStyles.hBetweenItems,
                                                globalStyles.mb2
                                            ]}
                                        >
                                            <View style={{ width: '65%', justifyContent: 'center' }}>
                                                <Text
                                                    style={[
                                                        globalStyles.inputLabel,
                                                        globalStyles.inputLabelLarge,
                                                        globalStyles.inputLabelPrimary
                                                    ]}
                                                >
                                                    {
                                                        `Enter “0“ if you are a dependent on another individual’s Ohio return; otherwise enter “1”`
                                                    }
                                                </Text>
                                            </View>
                                            <View style={{ width: '30%', overflow: 'hidden' }}>
                                                <TextInput
                                                    style={[globalStyles.input, globalStyles.inputLight]}
                                                    value={props.values.isDependent}
                                                    keyboardType="numeric"
                                                    onChangeText={(text) => {
                                                        if (text === '' || /^\d+$/.test(text)) {
                                                            props.handleChange('isDependent')(text)
                                                        }
                                                    }}
                                                />
                                                {props.touched.isDependent &&
                                                    props.errors.isDependent && (
                                                        <Text style={globalStyles.dangerAlert}>
                                                            {props.errors.isDependent}
                                                        </Text>
                                                    )}
                                            </View>
                                        </View>
                                        <View
                                            style={[
                                                globalStyles.hDirection,
                                                globalStyles.hBetweenItems,
                                                globalStyles.mb2
                                            ]}
                                        >
                                            <View style={{ width: '65%', justifyContent: 'center' }}>
                                                <Text
                                                    style={[
                                                        globalStyles.inputLabel,
                                                        globalStyles.inputLabelLarge,
                                                        globalStyles.inputLabelPrimary
                                                    ]}
                                                >
                                                    {
                                                        `Enter “0” if single or if your spouse files a separate Ohio return; otherwise enter “1“`
                                                    }
                                                </Text>
                                            </View>
                                            <View style={{ width: '30%', overflow: 'hidden' }}>
                                                <TextInput
                                                    style={[globalStyles.input, globalStyles.inputLight]}
                                                    value={props.values.isSingle}
                                                    keyboardType="numeric"
                                                    onChangeText={(text) => {
                                                        if (text === '' || /^\d+$/.test(text)) {
                                                            props.handleChange('isSingle')(text)
                                                        }
                                                    }}
                                                />
                                                {props.touched.isSingle &&
                                                    props.errors.isSingle && (
                                                        <Text style={globalStyles.dangerAlert}>
                                                            {props.errors.isSingle}
                                                        </Text>
                                                    )}
                                            </View>
                                        </View>
                                        <View
                                            style={[
                                                globalStyles.hDirection,
                                                globalStyles.hBetweenItems,
                                                globalStyles.mb2
                                            ]}
                                        >
                                            <View style={{ width: '65%', justifyContent: 'center' }}>
                                                <Text
                                                    style={[
                                                        globalStyles.inputLabel,
                                                        globalStyles.inputLabelLarge,
                                                        globalStyles.inputLabelPrimary
                                                    ]}
                                                >
                                                    {
                                                        `Number of dependents`
                                                    }
                                                </Text>
                                            </View>
                                            <View style={{ width: '30%', overflow: 'hidden' }}>
                                                <TextInput
                                                    style={[globalStyles.input, globalStyles.inputLight]}
                                                    value={props.values.noOfDependents}
                                                    keyboardType="numeric"
                                                    onChangeText={(text) => {
                                                        if (text === '' || /^\d+$/.test(text)) {
                                                            props.handleChange('noOfDependents')(text)
                                                        }
                                                    }}
                                                />
                                                {props.touched.noOfDependents &&
                                                    props.errors.noOfDependents && (
                                                        <Text style={globalStyles.dangerAlert}>
                                                            {props.errors.noOfDependents}
                                                        </Text>
                                                    )}
                                            </View>
                                        </View>
                                        {getCheckedIds().length === 0 && (
                                            <View
                                                style={[
                                                    globalStyles.hDirection,
                                                    globalStyles.hBetweenItems,
                                                    globalStyles.mb2
                                                ]}
                                            >
                                                <View style={{ width: '65%', justifyContent: 'center' }}>
                                                    <Text
                                                        style={[
                                                            globalStyles.inputLabel,
                                                            globalStyles.inputLabelLarge,
                                                            globalStyles.inputLabelPrimary
                                                        ]}
                                                    >
                                                        {
                                                            `Additional Ohio income tax withholding per pay period`
                                                        }
                                                    </Text>
                                                </View>
                                                <View style={{ width: '30%', overflow: 'hidden' }}>
                                                    <TextInput
                                                        style={[globalStyles.input, globalStyles.inputLight]}
                                                        value={props.values.additionalWithholding}
                                                        keyboardType="numeric"
                                                        onChangeText={(text) => {
                                                            if (text === '' || /^\d+$/.test(text)) {
                                                                props.handleChange('additionalWithholding')(text)
                                                            }
                                                        }}
                                                    />
                                                    {props.touched.additionalWithholding &&
                                                        props.errors.additionalWithholding && (
                                                            <Text style={globalStyles.dangerAlert}>
                                                                {props.errors.additionalWithholding}
                                                            </Text>
                                                        )}
                                                </View>
                                            </View>
                                        )}


                                        <View
                                            style={[
                                                globalStyles.mb2
                                            ]}
                                        >
                                            <View style={{ justifyContent: 'center', }}>
                                                <Text
                                                    style={[
                                                        globalStyles.inputLabel,
                                                        globalStyles.inputLabelLarge,
                                                        globalStyles.inputLabelPrimary
                                                    ]}
                                                >
                                                    {
                                                        'I am not subject to Ohio or school district income tax withholding because (check all that apply)'
                                                    }
                                                </Text>
                                            </View>
                                            <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
                                                {checkboxes.map(checkbox => (
                                                    <CheckBox
                                                        key={checkbox.id}
                                                        title={checkbox.title}
                                                        checked={checkbox.isChecked}
                                                        onPress={() => {
                                                            const newCheckboxes = checkboxes.map(cb =>
                                                                cb.id === checkbox.id ? { ...cb, isChecked: !cb.isChecked } : { ...cb, isChecked: false }
                                                            );
                                                            setCheckboxes(newCheckboxes);
                                                            const checkedIds = newCheckboxes
                                                                .filter(cb => cb.isChecked)
                                                                .map(cb => cb.id.toString());
                                                            props.setFieldValue("withholdingWaiver", checkedIds);
                                                            if (checkedIds.length > 0) {
                                                                props.setFieldValue("additionalWithholding", "");
                                                            }
                                                        }}
                                                        checkedColor="#0B495C"
                                                        uncheckedColor="#0B495C"
                                                        containerStyle={{ backgroundColor: 'transparent', borderWidth: 0, width: "100%", }}
                                                        titleProps={{
                                                            style: {
                                                                fontWeight: "normal",
                                                                color: "#0B495C",
                                                                flex: 1,
                                                            }
                                                        }}
                                                    />
                                                ))}
                                            </View>
                                            {props.touched.withholdingWaiver &&
                                                props.errors.withholdingWaiver && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.withholdingWaiver as string}
                                                    </Text>
                                                )}
                                        </View>





                                        {loading ? (
                                            <ActivityIndicator />
                                        ) : (
                                            <View style={{ margin: 10 }}>
                                                <CustomButton
                                                    text={mode === 'upload' ? 'Submit Information' : 'Next'}
                                                    onPress={props.handleSubmit}
                                                />
                                            </View>
                                        )}
                                    </>}
                            </Card>
                        </View>
                    )}
                </Formik>
            </View>

        </KeyboardAwareScrollView>
    )
}

export default OhInformationForm
